export default __webpack_public_path__ + "static/media/yext-logo.6d245888.png";